<template>
  <div class="flex items-center space-x-2 cursor-pointer">
    <div class="flex items-center">
      <ImageComposition :layers="comp1" class="z-[3] rounded-sm overflow-hidden" />
      <ImageComposition :layers="comp2" class="z-[2] rounded-sm overflow-hidden ml-[-29.5px]" />
      <ImageComposition :layers="comp3" class="z-[1] rounded-sm overflow-hidden ml-[-28px]" />
    </div>
    <span class="text-typo-secondary text-sm underline">{{ buttonText }}</span>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { ImageComposition } from "prism";

const I18n = inject("I18n", window.I18n);

const bgCta1 = "/images/canva-cta/bg_cta_1.jpg";
const bgCta2 = "/images/canva-cta/bg_cta_2.jpg";
const bgCta3 = "/images/canva-cta/bg_cta_3.jpg";

const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  canva_cta_variant: {
    type: String,
    required: true,
  },
});

const buttonText = props.canva_cta_variant === "control" ? I18n.t("canva_cta.common.add_design") : "Create Design";

const defaultBackgroundPlacement = {
  top: "0",
  left: "0",
  width: "auto",
  height: "auto",
  rotation: 0,
};

const defaultPlacement = {
  position: "absolute",
  rotation: 0,
  left: "50%",
  top: "50%",
  width: "auto",
  height: "auto",
};

const comp1 = [
  {
    src: bgCta1,
    alt: "First background",
    placement: {
      ...defaultBackgroundPlacement,
      maxHeight: "47px",
      maxWidth: "47px",
    },
  },
  {
    src: props.image,
    alt: "Image with removed background",
    placement: {
      ...defaultPlacement,
      maxHeight: "40px",
      maxWidth: "40px",
    },
  },
];

const comp2 = [
  {
    src: bgCta2,
    alt: "First background",
    placement: {
      ...defaultBackgroundPlacement,
      maxHeight: "43px",
      maxWidth: "43px",
    },
  },
  {
    src: props.image,
    alt: "Image with removed background",
    placement: {
      ...defaultPlacement,
      maxHeight: "36px",
      maxWidth: "36px",
    },
  },
];

const comp3 = [
  {
    src: bgCta3,
    alt: "First background",
    placement: {
      ...defaultBackgroundPlacement,
      maxHeight: "39px",
      maxWidth: "39px",
    },
  },
  {
    src: props.image,
    alt: "Image with removed background",
    placement: {
      ...defaultPlacement,
      maxHeight: "32px",
      maxWidth: "32px",
    },
  },
];
</script>
